import { ChangeDetectionStrategy, Component, input } from '@angular/core';

import { ProjectDetailsComponent } from './components/project-details/project-details.component';
import { ContactDetailsComponent } from './components/contact-details/contact-details.component';
import { ProjectInfo } from './models/project-info.types';

@Component({
  selector: 'app-project-info',
  imports: [ProjectDetailsComponent, ContactDetailsComponent],
  templateUrl: './project-info.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ProjectInfoComponent {
  readonly projectInfo = input.required<ProjectInfo>();
}
